<template>
  <div>
    <!-- <method-child @methodTwo="methodLast" @methodTwoThree="methodLastTwo" @methodTwoFour="methodLastThree"></method-child> -->
    <method-child @one='method1' @two='method2' @tree='method3'></method-child>
  </div>
</template>

<script>
import MethodChild from './MethodChild'
export default {
  components:{
    MethodChild
  },
  methods:{
    method1: function(obj){
     console.log('first msg')
     alert(obj.msg1)
    },
    method2: function(obj){
      console.log('sencond message')
      alert(obj.msg2)
    },
    method3 :function(value){
      console.log('third message')
      alert(value.msg3)
    }
  }
}
</script>

<style scoped>

</style>